{
  "Billing": "Abrechnung",
  "Return to App": "Zurück zur App",
  "Home": "Startseite",
  "Calendar": "Kalender",
  "Dashboard": "Dashboard",
  "ATP": "ATP",
  "Subscriptions": "Abonnements",
  "Payment Methods": "Zahlungsmethoden",
  "Purchases": "Käufe",
  "View Profile": "Profil anzeigen",
  "TrainingPeaks Athlete Since": "TrainingPeaks-Athlet seit",
  "TrainingPeaks Coach Since": "TrainingPeaks-Trainer seit",
  "Invoice": "Rechnung",
  "No results": "Keine Ergebnisse",
  "qtr": "Quartal",
  "Show all transactions": "Alle Transaktionen anzeigen",
  "No transactions found": "Keine Transaktionen gefunden",
  "Loading purchases": "Käufe werden geladen",
  "Error loading purchases": "Fehler beim Laden der Käufe",
  "Active": "Aktiv",
  "Inactive": "Inaktiv",
  "Cancelled": "Gekündigt",
  "PastDue": "Überfällig",
  "Trialing": "Testphase",
  "Next Renewal": "Nächste Verlängerung",
  "Manage": "Verwalten",
  "plus tax": "zzgl. Steuern",
  "No subscriptions found": "Keine Abonnements gefunden",
  "No purchases found": "Keine Käufe gefunden",
  "Show all": "Alle anzeigen",
  "Show less": "Weniger anzeigen",
  "Date": "Datum",
  "Description": "Beschreibung",
  "Amount": "Betrag",
  "Status": "Status",
  "Paid": "Bezahlt",
  "Failed": "Fehlgeschlagen",
  "Pending": "Ausstehend",
  "Refunded": "Erstattet",
  "Loading": "Wird geladen",
  "Error loading data": "Fehler beim Laden der Daten",
  "month": "Monat",
  "year": "Jahr",
  "quarter": "Quartal",
  "mo": "Mon.",
  "yr": "Jahr",
  "Default": "Standard",
  "Expires": "Läuft ab",
  "Card ending in": "Karte endet auf",
  "Flexible planning to fit your life": "Flexible Planung für Ihr Leben",
  "Actionable Insights to keep you on track": "Umsetzbare Erkenntnisse, die Sie auf Kurs halten",
  "Strength training to avoid injury": "Krafttraining zur Vermeidung von Verletzungen",
  "Ride the world inside on Virtual": "Die Welt drinnen mit Virtual erleben",
  "Any sport, any device, any time": "Jeder Sport, jedes Gerät, jederzeit",
  "Annual": "Jährlich",
  "Monthly": "Monatlich",
  "Billed USD $134.99/yr": "Abrechnung: 134,99 USD/Jahr",
  "Most Popular": "Am beliebtesten",
  "$19.95 $11.25/mo": "19,95 $ 11,25 $/Monat",
  "$19.95/mo": "19,95 $/Monat",
  "Checkout": "Zur Kasse",
  "Progress starts with Premium.": "Fortschritt beginnt mit Premium.",
  "Add Card": "Karte hinzufügen",
  "Close": "Schließen",
  "Primary": "Primär",
  "Delete": "Löschen",
  "Make Primary": "Als primär festlegen",
  "Error loading payment methods": "Fehler beim Laden der Zahlungsmethoden",
  "Your card has expired. Please add a new card.": "Ihre Karte ist abgelaufen. Bitte fügen Sie eine neue Karte hinzu.",
  "Unable to load payment form. Please try again later.": "Das Zahlungsformular konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
  "A temporary $1.00 charge will be made to validate your payment method. This charge is automatically refunded.": "Zur Überprüfung Ihrer Zahlungsmethode wird vorübergehend 1,00 $ belastet. Dieser Betrag wird automatisch erstattet.",
  "Payment method added successfully": "Zahlungsmethode erfolgreich hinzugefügt",
  "Default payment method updated": "Standardzahlungsmethode aktualisiert",
  "Payment method deleted": "Zahlungsmethode gelöscht",
  "Failed to set default payment method": "Standardzahlungsmethode konnte nicht festgelegt werden",
  "Failed to update default payment method": "Standardzahlungsmethode konnte nicht aktualisiert werden",
  "Failed to delete payment method": "Zahlungsmethode konnte nicht gelöscht werden",
  "Maximize Your Premium Subscription \n Before You Go!": "Holen Sie das Beste aus Ihrem Premium-Abonnement heraus,\nbevor Sie gehen!",
  "TrainingPeaks Virtual": "TrainingPeaks Virtual",
  "Ride inside with our virtual cycling experience": "Fahren Sie drinnen mit unserem virtuellen Radsporterlebnis",
  "Strength Builder": "Krafttrainer",
  "Create and save strength workouts": "Erstellen und speichern Sie Krafttrainings",
  "Metrics Charts": "Metrikdiagramme",
  "Analyze metrics from your synced devices": "Analysieren Sie Daten Ihrer synchronisierten Geräte",
  "Performance Metrics": "Leistungskennzahlen",
  "Fitness (CTL), Fatigue (ATL) and Form (TSB)": "Fitness (CTL), Ermüdung (ATL) und Form (TSB)",
  "Peak Performances": "Bestleistungen",
  "Track and compare your best efforts": "Verfolgen und vergleichen Sie Ihre besten Leistungen",
  "NEW!": "NEU!",
  "Cancel Subscription": "Abonnement kündigen",
  "Renew Subscription": "Abonnement verlängern",
  "Complimentary": "Kostenlos",
  "Your complimentary access is active through": "Ihr kostenloser Zugang ist aktiv bis",
  "Keep your goals in sight -- renew Premium to stay on track for race day.": "Behalten Sie Ihre Ziele im Blick - verlängern Sie Premium, um bis zum Wettkampftag auf Kurs zu bleiben.",
  "Renew": "Verlängern",
  "Auto-Renew Off": "Automatische Verlängerung deaktiviert",
  "Access through": "Zugang bis",
  "Turn Auto-Renew On": "Automatische Verlängerung aktivieren",
  "Are you sure you want to cancel coaching?": "Möchtest du das Coaching wirklich kündigen?",
  "Reaching your goals takes the right fit. Before you cancel, let us know if you need to pause, adjust your package level, or speak directly with a Coach Match Specialist.": "Deine Ziele zu erreichen, erfordert die richtige Betreuung. Bevor du kündigst, sag uns, ob du pausieren, dein Paketlevel anpassen oder direkt mit einem Coach-Match-Spezialisten sprechen möchtest.",
  "Pause, Adjust, or Contact Support": "Pausieren, anpassen oder Support kontaktieren",
  "Yes, Cancel": "Ja, kündigen",
  "Keep My Coaching": "Coaching behalten",
  "Coach Match subscription: Pause, Adjust, or Speak with Specialist": "Coach-Match-Abonnement: Pausieren, anpassen oder mit einem Spezialisten sprechen",
  "Hi Coach Match Team,\n\nI am reaching out regarding my coaching membership. Before deciding whether to cancel, I would like to [pause my membership / adjust my package level / speak with a Coach Match Specialist].\n\nMy account email is: [Your Email]\n\nThanks!": "Hallo Coach-Match-Team,\n\nich melde mich bezüglich meiner Coaching-Mitgliedschaft. Bevor ich mich entscheide, ob ich kündigen möchte, würde ich gerne [meine Mitgliedschaft pausieren / mein Paketlevel anpassen / mit einem Coach-Match-Spezialisten sprechen].\n\nMeine Konto-E-Mail lautet: [Ihre E-Mail]\n\nVielen Dank!",
  "Before you go...": "Bevor du gehst...",
  "What's the reason for canceling?": "Was ist der Grund für die Kündigung?",
  "Price / Financial Reasons": "Preis / Finanzielle Gründe",
  "The subscription cost no longer fits my budget.": "Die Abonnementkosten passen nicht mehr in mein Budget.",
  "Injured / Health Reasons": "Verletzung / Gesundheitliche Gründe",
  "I'm unable to train due to injury or health.": "Ich kann aufgrund von Verletzung oder Gesundheit nicht trainieren.",
  "Finished Goal Event": "Zielereignis abgeschlossen",
  "I completed my target race or event.": "Ich habe mein Zielrennen oder mein Event abgeschlossen.",
  "Poor Experience / Fit": "Schlechte Erfahrung / Passt nicht",
  "The coaching style or program wasn't the right match.": "Der Coaching-Stil oder das Programm war nicht die richtige Wahl.",
  "Temporary Pause / Restart Later": "Vorübergehende Pause / Später fortsetzen",
  "Life got busy — I'd like to come back when I'm ready.": "Das Leben wurde hektisch – ich möchte zurückkommen, wenn ich bereit bin.",
  "Other": "Sonstiges",
  "Optional: Why?": "Optional: Warum?",
  "Continue": "Weiter",
  "Keep Subscription": "Abonnement behalten"
}
